import React from 'react';

function SkeletonTable({ rows = 5 }) {
  return (
    <div className="table-container" aria-busy="true" aria-label="Loading terminations">
      <table className="termination-table">
        <thead>
          <tr>
            {['Ticket', 'Employee', 'Processing Time', 'Approved By', 'Lit Hold', 'Actions'].map((h) => (
              <th key={h}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }, (_, i) => (
            <tr key={i} className="skeleton-row">
              {[80, 180, 140, 150, 60, 160].map((w, j) => (
                <td key={j}>
                  <div
                    className="skeleton-bar"
                    style={{
                      width: `${w}px`,
                      animationDelay: `${i * 80 + j * 40}ms`,
                    }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default SkeletonTable;
